(()=>{
  const root=(window.wayfairTheme&&window.wayfairTheme.root)||'/';
  const qs=(selector,scope=document)=>scope.querySelector(selector);
  const qsa=(selector,scope=document)=>Array.from(scope.querySelectorAll(selector));
  const drawer=qs('[data-wf-cart-drawer]');
  const menu=qs('[data-wf-menu]');
  const menuButton=qs('[data-wf-menu-open]');
  const money=(cents)=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(Number(cents||0)/100);
  const lock=(active)=>document.body.classList.toggle('wf-lock',active);

  function setMenu(open){if(!menu)return;menu.hidden=!open;menuButton?.setAttribute('aria-expanded',String(open));lock(open)}
  function setCart(open){if(!drawer)return;drawer.hidden=!open;drawer.setAttribute('aria-hidden',String(!open));lock(open);if(open)refreshCart()}
  qsa('[data-wf-menu-open]').forEach((button)=>button.addEventListener('click',()=>setMenu(true)));
  qsa('[data-wf-menu-close]').forEach((button)=>button.addEventListener('click',()=>setMenu(false)));
  qsa('[data-wf-cart-open]').forEach((button)=>button.addEventListener('click',()=>setCart(true)));
  qsa('[data-wf-cart-close]').forEach((button)=>button.addEventListener('click',()=>setCart(false)));
  document.addEventListener('keydown',(event)=>{if(event.key==='Escape'){setMenu(false);setCart(false)}});

  qsa('[data-wf-hero]').forEach((hero)=>{
    const track=qs('.wf-hero-track',hero);
    const slides=qsa('[data-wf-hero-slide]',hero);
    const dots=qsa('[data-wf-hero-dot]',hero);
    if(!track||!slides.length)return;
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let active=0;
    let position=1;
    let timer=0;
    let touchStart=null;
    const cloneSlide=(source)=>{
      const clone=source.cloneNode(true);
      clone.removeAttribute('data-wf-hero-slide');
      clone.classList.remove('is-active');
      clone.classList.add('wf-hero-clone');
      clone.setAttribute('aria-hidden','true');
      qsa('a,button,input,select,textarea,[tabindex]',clone).forEach((element)=>element.setAttribute('tabindex','-1'));
      return clone;
    };
    track.prepend(cloneSlide(slides[slides.length-1]));
    track.append(cloneSlide(slides[0]));
    const setPosition=(next)=>{position=next;track.style.setProperty('--wf-hero-position',String(position))};
    const render=()=>{
      slides.forEach((slide,index)=>{
        const current=index===active;
        slide.classList.toggle('is-active',current);
        slide.setAttribute('aria-hidden',String(!current));
        qs('a',slide)?.setAttribute('tabindex',current?'0':'-1');
      });
      dots.forEach((dot,index)=>{
        const current=index===active;
        dot.classList.toggle('is-active',current);
        dot.setAttribute('aria-current',String(current));
      });
    };
    const snap=(next)=>{
      track.classList.add('is-snapping');
      setPosition(next);
      void track.offsetWidth;
      track.classList.remove('is-snapping');
    };
    const stop=()=>{if(timer){window.clearInterval(timer);timer=0}};
    const show=(next,restart=false)=>{
      const normalized=(next+slides.length)%slides.length;
      let target=normalized+1;
      if(active===slides.length-1&&normalized===0)target=slides.length+1;
      else if(active===0&&normalized===slides.length-1)target=0;
      active=normalized;
      render();
      setPosition(target);
      if(reduced&&target===0)snap(slides.length);
      else if(reduced&&target===slides.length+1)snap(1);
      if(restart)start();
    };
    const start=()=>{stop();if(!reduced&&slides.length>1&&!document.hidden)timer=window.setInterval(()=>show(active+1),10000)};
    track.addEventListener('transitionend',(event)=>{
      if(event.target!==track||event.propertyName!=='transform')return;
      if(position===0)snap(slides.length);
      else if(position===slides.length+1)snap(1);
    });
    dots.forEach((dot)=>dot.addEventListener('click',()=>show(Number(dot.dataset.wfHeroDot)||0,true)));
    hero.addEventListener('mouseenter',stop);
    hero.addEventListener('mouseleave',start);
    hero.addEventListener('focusin',stop);
    hero.addEventListener('focusout',(event)=>{if(!hero.contains(event.relatedTarget))start()});
    hero.addEventListener('touchstart',(event)=>{touchStart=event.changedTouches[0]?.clientX??null;stop()},{passive:true});
    hero.addEventListener('touchend',(event)=>{
      if(touchStart!==null){const delta=(event.changedTouches[0]?.clientX??touchStart)-touchStart;if(Math.abs(delta)>45)show(active+(delta<0?1:-1));touchStart=null}
      start();
    },{passive:true});
    document.addEventListener('visibilitychange',()=>document.hidden?stop():start());
    setPosition(1);
    render();
    void track.offsetWidth;
    track.classList.add('is-ready');
    start();
  });

  qsa('[data-wf-rail]').forEach((rail)=>{
    const track=qs('[data-wf-rail-track]',rail);
    const previous=qs('[data-wf-rail-prev]',rail);
    const next=qs('[data-wf-rail-next]',rail);
    if(!track)return;
    track.tabIndex=0;
    const update=()=>{
      const maximum=Math.max(0,track.scrollWidth-track.clientWidth);
      if(previous)previous.hidden=track.scrollLeft<=4;
      if(next)next.hidden=maximum<=4||track.scrollLeft>=maximum-4;
    };
    const move=(direction)=>track.scrollBy({left:direction*Math.max(240,track.clientWidth*.88),behavior:'smooth'});
    previous?.addEventListener('click',()=>move(-1));
    next?.addEventListener('click',()=>move(1));
    track.addEventListener('scroll',update,{passive:true});
    track.addEventListener('keydown',(event)=>{if(event.key==='ArrowRight'){event.preventDefault();move(1)}if(event.key==='ArrowLeft'){event.preventDefault();move(-1)}});
    if('ResizeObserver'in window)new ResizeObserver(update).observe(track);
    window.setTimeout(update,100);
  });

  const footerGroups=qsa('[data-wf-footer-group]');
  if(footerGroups.length){
    const footerBreakpoint=window.matchMedia('(min-width: 761px)');
    const syncFooterGroups=(desktop)=>footerGroups.forEach((group)=>group.toggleAttribute('open',desktop));
    syncFooterGroups(footerBreakpoint.matches);
    footerBreakpoint.addEventListener?.('change',(event)=>syncFooterGroups(event.matches));
  }

  async function jsonFetch(path,options){const response=await fetch(`${root}${path}`,options);if(!response.ok)throw new Error(`Request failed: ${response.status}`);return response.json()}
  function updateCount(count){qsa('[data-wf-cart-count]').forEach((node)=>{node.textContent=String(count);node.hidden=count<1})}
  function element(name,className,text){const node=document.createElement(name);if(className)node.className=className;if(text!==undefined)node.textContent=text;return node}
  function quantityButton(step,label){const button=element('button','',step<0?'−':'+');button.type='button';button.setAttribute('aria-label',label);button.dataset.wfQuantityStep=String(step);return button}
  function quantityControl(input,title){const control=element('div','wf-quantity-control');control.dataset.wfQuantityControl='';control.append(quantityButton(-1,`Decrease ${title} quantity`),input,quantityButton(1,`Increase ${title} quantity`));return control}
  async function changeCartLine(line,quantity,context){
    const cart=await jsonFetch('cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:Number(line),quantity:Math.max(0,Number(quantity)||0)})});
    updateCount(cart.item_count);
    if(context==='page'){window.location.reload();return cart}
    await refreshCart();return cart;
  }
  async function refreshCart(){
    try{
      const cart=await jsonFetch('cart.js');updateCount(cart.item_count);
      const host=qs('[data-wf-cart-items]');if(!host)return;host.replaceChildren();
      if(!cart.items.length){host.append(element('p','wf-cart-empty','Your cart is empty.'))}
      cart.items.forEach((item,index)=>{
        const article=element('article');const imageLink=element('a');imageLink.href=item.url;
        if(item.image){const image=new Image();image.src=item.image;image.alt=item.product_title;image.loading='lazy';imageLink.append(image)}
        const copy=element('div');const title=element('a');title.href=item.url;title.append(element('strong','',item.product_title));copy.append(title);
        if(item.variant_title)copy.append(element('small','',item.variant_title));copy.append(element('span','',money(item.final_line_price)));
        copy.append(element('span','wf-cart-line-label','Quantity'));
        const actions=element('div','wf-cart-item-actions');const input=element('input');input.type='number';input.min='1';input.inputMode='numeric';input.value=String(item.quantity);input.setAttribute('aria-label',`Quantity for ${item.product_title}`);input.dataset.wfCartQuantity='';input.dataset.wfCartContext='drawer';input.dataset.line=String(index+1);
        const remove=element('button','wf-cart-remove','Remove');remove.type='button';remove.dataset.wfCartRemove='';remove.dataset.wfCartContext='drawer';remove.dataset.line=String(index+1);actions.append(quantityControl(input,item.product_title),remove);copy.append(actions);
        article.append(imageLink,copy);host.append(article);
      });
      const total=qs('[data-wf-cart-total]');if(total)total.textContent=money(cart.total_price);
    }catch(error){console.error(error)}
  }
  document.addEventListener('click',async(event)=>{
    const stepButton=event.target.closest('[data-wf-quantity-step]');
    if(stepButton){
      const control=stepButton.closest('[data-wf-quantity-control]');const input=qs('input',control);if(!input||input.dataset.busy==='true')return;
      const minimum=Math.max(1,Number(input.min)||1);const current=Math.max(minimum,Number(input.value)||minimum);const next=Math.max(minimum,current+Number(stepButton.dataset.wfQuantityStep||0));input.value=String(next);if(next===current)return;
      if(input.matches('[data-wf-cart-quantity]')){input.dataset.busy='true';try{await changeCartLine(input.dataset.line,next,input.dataset.wfCartContext)}catch(error){console.error(error);input.dataset.busy='false'}}
      return;
    }
    const removeButton=event.target.closest('[data-wf-cart-remove]');
    if(removeButton){event.preventDefault();if(removeButton.disabled)return;removeButton.disabled=true;try{await changeCartLine(removeButton.dataset.line,0,removeButton.dataset.wfCartContext)}catch(error){console.error(error);removeButton.disabled=false}return}
    const button=event.target.closest('[data-wayfair-add]');if(!button)return;
    const original=button.textContent;button.disabled=true;button.textContent='Adding…';
    try{await jsonFetch('cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(button.dataset.variantId),quantity:1}]})});await refreshCart();setCart(true)}
    catch(error){console.error(error);button.textContent='Try again';setTimeout(()=>{button.textContent=original;button.disabled=false},1800);return}
    button.textContent=original;button.disabled=false;
  });
  document.addEventListener('change',async(event)=>{
    const input=event.target.closest('[data-wf-cart-quantity]');if(!input)return;
    const quantity=Math.max(1,Number(input.value)||1);input.value=String(quantity);input.dataset.busy='true';
    try{await changeCartLine(input.dataset.line,quantity,input.dataset.wfCartContext)}catch(error){console.error(error);input.dataset.busy='false'}
  });
  qsa('[data-wf-product]').forEach((product)=>{
    const select=qs('[data-wf-variant-select]',product);if(!select)return;
    select.addEventListener('change',()=>{
      const option=select.selectedOptions[0];const formId=qs('[name="id"]',product);if(formId)formId.value=select.value;
      const price=qs('[data-wf-product-price]',product);if(price)price.textContent=money(option.dataset.price);
      const compare=qs('[data-wf-compare-price]',product);if(compare){compare.textContent=money(option.dataset.compare);compare.hidden=Number(option.dataset.compare)<=Number(option.dataset.price)}
      const submit=qs('[data-wf-product-submit]',product);if(submit){const available=option.dataset.available==='true';submit.disabled=!available;submit.textContent=available?'Add to cart':'Sold out'}
      const mediaId=option.dataset.mediaId;const mediaButton=mediaId?qs(`[data-wf-media-id="${CSS.escape(mediaId)}"]`,product):null;mediaButton?.click();
    });
  });
  qsa('[data-wf-media-id]').forEach((button)=>button.addEventListener('click',()=>{
    const product=button.closest('[data-wf-product]');const main=qs('[data-wf-main-image]',product);const image=qs('img',button);if(!main||!image)return;
    main.src=image.dataset.large||image.src;main.alt=image.alt;qsa('[data-wf-media-id]',product).forEach((item)=>item.classList.toggle('active',item===button));
  }));
})();
